import { render } from "./WithdrawalsBase.vue?vue&type=template&id=0a7d7208"
import script from "./WithdrawalsBase.vue?vue&type=script&lang=js"
export * from "./WithdrawalsBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./WithdrawalsBase.vue?vue&type=style&index=0&id=0a7d7208&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script